import SimplePromptResponsePage from './SimplePromptResponsePage';

export default SimplePromptResponsePage;
